import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import BlocThematique from './BlocThematique.js';

const BlocThematiqueList = ({ blocs }) => (
  <DndProvider backend={HTML5Backend}>
    <div className="blocs-thematiques">
      {blocs.map((bloc, index) => (
        <BlocThematique bloc={bloc} showOperateur={index > 0} key={bloc.id} />
      ))}
    </div>
  </DndProvider>
);
BlocThematiqueList.propTypes = {
  blocs: PropTypes.array.isRequired,
};

export default BlocThematiqueList;
